<template>
  <ModalTemplate @close="$store.dispatch('afterJoin')">
    <template v-slot:body>
      <div class="modal-block" @click.stop>
        <!-- <div class="modal-close" @click="$store.dispatch('afterJoin')">
          <img src="@/assets/images/icons/icon_close.svg" />
        </div> -->
        <div class="modal-image">
          <img src="@/assets/images/party-popper.png" />
        </div>
        <h4 class="modal-title">Вы присоединились к событию!</h4>
        <p class="modal-text">Теперь вы можете добавлять фотографии, участников, и пользоваться чатом события.</p>
        <div class="modal-body">
          <!-- <div class="modal-notif">
            <p class="modal-notif__text">Напомнить за</p>
            <vSelect :options="options" v-model="selected" />
            <p class="modal-notif__text">до начала.</p>
          </div> -->
          <div class="modal-string center">
            <!-- <div class="modal-route button" @click="setDestination()">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><path d="m371.244 114.479c0-24.831-20.188-45.031-45.004-45.031-24.814 0-45.003 20.201-45.003 45.031s20.188 45.031 45.003 45.031c24.816.001 45.004-20.2 45.004-45.031zm-45.004 15.032c-8.272 0-15.003-6.743-15.003-15.031s6.73-15.031 15.003-15.031 15.004 6.743 15.004 15.031-6.73 15.031-15.004 15.031z" fill="#ffffff" data-original="#000000" style="" class=""/><path d="m455.496 353.367h-278.118c-14.08 0-25.534-11.472-25.534-25.573s11.454-25.573 25.534-25.573h148.862c5.461 0 9.639-2.658 12.93-7.181l78.874-108.502c58.09-75.501 4.473-186.538-91.803-186.538-94.341 0-150.043 107.818-92.324 185.876l64.057 86.345h-120.596c-30.622 0-55.534 24.93-55.534 55.573s24.912 55.573 55.534 55.573h278.118c14.614 0 26.504 11.907 26.504 26.543s-11.89 26.543-26.504 26.543h-336.368c-6.686-26.154-30.433-45.547-58.623-45.547-33.362-.001-60.505 27.161-60.505 60.547s27.143 60.547 60.505 60.547c28.19 0 51.937-19.394 58.623-45.547h336.368c31.156 0 56.504-25.365 56.504-56.543s-25.348-56.543-56.504-56.543zm-197.574-185.506c-42.554-55.972-2.835-137.861 68.319-137.861 71.611 0 111.066 82.727 67.826 138.503-.126.162-67.07 92.261-67.153 92.375-.075-.1-68.915-92.917-68.992-93.017zm-197.417 314.139c-16.82 0-30.505-13.704-30.505-30.547s13.685-30.547 30.505-30.547 30.505 13.704 30.505 30.547-13.685 30.547-30.505 30.547z" fill="#ffffff" data-original="#000000" style="" class=""/></g></g></svg>
              <p>Проложить маршрут</p>
            </div> -->
            <div class="modal-friends map-button" v-if="userCanAdd" @click="$store.dispatch('changeState', {element:'invite'})">
              <p>Пригласить друзей</p>
            </div>
            <div class="modal-chat map-button" v-if="getActiveEvent.chat" @click="$router.push({name: 'chat', params: {hash: getActiveEvent.chat.id + '&' + getActiveEvent.chat.hash}})">
              <p>Перейти в чат</p>
            </div>
          </div>
          <div class="modal-share">
            <!-- <h4>Рассказать друзьям о событии</h4> -->
            <div class="modal-socials" v-if="getActiveEvent">
              <ShareNetwork
                    network="vk"
                    :url="'https://wiildwood.online/'+$route.path"
                    :title="'Присоединяйтесь к событию ' + '«' + getActiveEvent.title + '»'"
                    :description="getActiveEvent.title"
                    :quote="getActiveEvent.title"
                    hashtags="wildwood"
                  >
                  <div class="modal-socials__item">
                    <img src="@/assets/images/socials/vk.svg" />
                  </div>
                </ShareNetwork>
                  <ShareNetwork
                    network="facebook"
                    :url="'https://wiildwood.online/'+$route.path"
                    :title="'Присоединяйтесь к событию ' + '«' + getActiveEvent.title + '»'"
                    :description="getActiveEvent.title"
                    :quote="getActiveEvent.title"
                    hashtags="wildwood"
                  >
                    <div class="modal-socials__item">
                      <img src="@/assets/images/socials/facebook.svg" />
                    </div>
                </ShareNetwork>
                <ShareNetwork
                    network="twitter"
                    :url="'https://wiildwood.online/'+$route.path"
                    :title="'Присоединяйтесь к событию ' + '«' + getActiveEvent.title + '»'"
                    :description="getActiveEvent.title"
                    :quote="getActiveEvent.title"
                    hashtags="wildwood"
                  >
                  <div class="modal-socials__item">
                    <img src="@/assets/images/socials/twitter.svg" />
                  </div>
                </ShareNetwork>
                <ShareNetwork
                    network="telegram"
                    :url="'https://wiildwood.online/'+$route.path"
                    :title="'Присоединяйтесь к событию ' + '«' + getActiveEvent.title + '»'"
                    :quote="getActiveEvent.title"
                    hashtags="wildwood"
                  >
                  <div class="modal-socials__item">
                    <img src="@/assets/images/socials/telegram.svg" />
                  </div>
                </ShareNetwork>
                <ShareNetwork
                    network="reddit"
                    :url="'https://wiildwood.online/'+$route.path"
                    :title="'Присоединяйтесь к событию ' + '«' + getActiveEvent.title + '»'"
                    :quote="getActiveEvent.title"
                    hashtags="wildwood"
                  >
                  <div class="modal-socials__item">
                    <img src="@/assets/images/socials/reddit.svg" />
                  </div>
                </ShareNetwork>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalTemplate>
</template>
<script>
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";

export default {
  name: "ModalEvent",
  data: () => {
    return {
      options: [
        "5 минут",
        "15 минут",
        "30 минут",
        "1 час",
        "2 часа",
        "3 часа",
        "4 часа",
        "5 часов",
        "1 день",
      ],
      selected: "2 часа",
    };
  },
  components: {
    ModalTemplate: () => import('@/components/Templates/Modal'),
  },
  computed: {
      userCanAdd () {
        return this.$store.getters.userCanAdd
      },
      getActiveEvent () {
        return this.$store.getters.getActiveEvent
      }
  },
  methods: {
    setDestination() {
      this.$store.dispatch('setDestinationId', this.getActiveEvent.id)
      this.$store.dispatch('setTransport', true)
      this.$store.dispatch('showJoined', false)
    }
  }
};
</script>
<style lang="stylus" scoped>
.modal
  &-share
    width 100%
  &-string
    width 100%
    .map-button
      margin 0 5px
</style>